/* ============================================================================
   LAS ENTIDADES QUE SE SINCRONIZAN

   ═══ EL NOMBRE DEL SERVIDOR NO ES EL DE LA PANTALLA ═══

   El servidor habla de `aeronaves` y `pilotos`; la aplicación guarda `flota` y
   `pilotos` en IndexedDB. `VistaDeGestion` ya tenía el mismo error —leía
   `fleet` y `pilots`— y mostraba una flota vacía sin fallar. La traducción vive
   acá, una sola vez, y una prueba comprueba que cada entidad tenga su clave.

   ═══ SOLO ARRAYS ═══

   El motor compara por `id` y reemplaza registros. Todo lo que se sincroniza
   tiene que ser una lista de objetos con `id`. `libroPiloto` queda afuera a
   propósito: se deriva de la bitácora, y sincronizar las dos versiones haría
   que una corrección se cuente dos veces.
   ========================================================================== */

export const ENTIDADES = [
    { nombre: "bitacora", clave: "bitacora", etiqueta: "Bitácora", orden: "recientes", leer: "vuelos.leer", escribir: "vuelos.escribir" },
    { nombre: "clientes", clave: "clientes", etiqueta: "Clientes", orden: "lista", leer: "empresa.leer", escribir: "empresa.escribir" },
    { nombre: "aeronaves", clave: "flota", etiqueta: "Flota", orden: "lista", leer: "empresa.leer", escribir: "empresa.escribir" },
    { nombre: "pilotos", clave: "pilotos", etiqueta: "Pilotos", orden: "lista", leer: "empresa.leer", escribir: "empresa.escribir" },
    { nombre: "eventosSgs", clave: "eventosSgs", etiqueta: "Eventos SGS", orden: "recientes", leer: "sgs.leer", escribir: "sgs.escribir" },
    { nombre: "auditorias", clave: "auditorias", etiqueta: "Auditorías", orden: "recientes", leer: "sgs.leer", escribir: "sgs.escribir" },
    { nombre: "noConformidades", clave: "noConformidades", etiqueta: "No conformidades", orden: "recientes", leer: "sgs.leer", escribir: "sgs.escribir" },
];

export const ENTIDAD_POR_NOMBRE = new Map(ENTIDADES.map((e) => [e.nombre, e]));

export function entidadPorNombre(nombre) {
    return ENTIDAD_POR_NOMBRE.get(nombre) || null;
}

export function claveDeEntidad(entidad) {
    return `estado:${entidad.clave}`;
}

export function etiquetaDeEntidad(nombre) {
    return entidadPorNombre(nombre)?.etiqueta || nombre;
}
